import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { installiereFehlerMelder } from "@/lib/fehlerMelder";
import { installiereDomSchutz } from "@/lib/domSchutz";

installiereDomSchutz(typeof window !== 'undefined' && window.Node ? window.Node.prototype : null);
installiereFehlerMelder();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
